import { useCallback } from 'react'

export const SimpleJson = ({ value }: { value: any }) => {
  const json = JSON.stringify(value, null, 2)
  const onClick = useCallback(() => {
    console.log(value)
  }, [value])
  return (
    <pre
      onClick={onClick}
      onKeyDown={onClick}
      className="bg-gray-800 text-gray-100 text-xs p-2 cursor-help overflow-auto"
    >
      {json}
    </pre>
  )
}
